import { useState, useEffect } from "react";

export const useDelayedLoading = (loadingPromises = [], delay = 300) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let loadingTimeout;
    let mounted = true;

    // Start loading timer
    loadingTimeout = setTimeout(() => {
      if (mounted) {
        setIsLoading(true);
      }
    }, delay);

    // Handle actual loading
    Promise.all(loadingPromises)
      .then(() => {
        if (mounted) {
          clearTimeout(loadingTimeout);
          setIsLoading(false);
          setIsComplete(true);
        }
      })
      .catch((err) => {
        if (mounted) {
          clearTimeout(loadingTimeout);
          setIsLoading(false);
          setError(err);
        }
      });

    return () => {
      mounted = false;
      clearTimeout(loadingTimeout);
    };
  }, [delay, loadingPromises]);

  return { isLoading, isComplete, error };
};
